import {GovNavItem} from "@gov-design-system-ce/react";
import React from "react";
import {NavLink} from "react-router-dom";

const IS_ACTIVE_CLASS = "is-active";

export interface NavItemLinkProps {
    to: string;
    hidden?: boolean;
    onClick?: () => void;
    children: React.ReactNode;
}

export default function NavItemLink(props: Readonly<NavItemLinkProps>) {
    const {children, to, hidden, onClick} = props;

    if (hidden) {
        return null;
    }

    return (
        <NavLink to={to}>
            {({isActive}) => (
                <GovNavItem className={isActive ? IS_ACTIVE_CLASS : ""}
                            onClick={onClick} >
                    {children}
                </GovNavItem>
            )}

        </NavLink>
    );
}
